import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { SelectItem } from 'primeng/api';
import { roles, textareaBox } from 'src/app/constant/constant';
import { DoctorList, NewMessage } from 'src/app/models/message';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { PatientService } from 'src/app/services/patient.service';
import {
  ErrorModel,
  PromiseResult,
  ServerError
} from '../../../models/PromiseResult';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
  selector: 'app-pcompose-email',
  templateUrl: './pcompose-email.component.html',
  styleUrls: [
    '../../../../assets/css/custom-egd.css',
    './pcompose-email.component.css'
  ]
})
@TraceClassDecorator()
export class PcomposeEmailComponent implements OnInit {
  readonly textarea: RegExp = textareaBox;
  members: SelectItem[] = [{ label: 'Select Member', value: null }];
  selectedMember: any;
  member_value: string = '0';
  readonly max_subject_length: number;
  readonly max_message_length: number;
  message: NewMessage;
  response: PromiseResult;
  error: ErrorModel;
  serverError: ServerError;
  slug: string = "";
  posting: boolean;
  private readonly user: roles;
  constructor(
    private router: Router,
    private readonly patientservice: PatientService,
    private titleService: Title,
    private readonly messageService: MessagecenterService,
    private readonly providerStateService: ProviderStateService
  ) {
    this.max_subject_length = 100;
    this.max_message_length = 500;
    this.posting = false;
    this.user = roles.patient;
  }

  ngOnInit(): void {
    this.slug = this.providerStateService.getProviderSlug();
    this.titleService.setTitle('Dashboard - Patient Compose Email');
    this.getMemberList();
    this.message = {
      patient_guid: null,
      user_guid: null,
      subject: '',
      message: '',
      reply_id: null
    };
    this.response = {
      success: null,
      error: null,
      data: null
    };
    this.serverError = {
      statusCode: null,
      error: null,
      message: null
    };
  }

  doctor_list: SelectItem[] = [];

  async ResetResultModels(): Promise<void> {
    this.response.success = null;
    this.response.error = null;
    this.response.data = null;
    this.serverError.message = null;
    this.serverError.error = null;
  }

  async GetDoctors(patient_guid: string): Promise<void> {
    await this.ResetResultModels();
    this.posting = true;
    await this.patientservice
      .GetDoctors(patient_guid)
      .toPromise()
      .then(async (result: PromiseResult) => {
        this.doctor_list = [];
        if (result.success) {
          await this.ProcessDoctors(result.data);
        } else {
          this.response = result;
        }
        this.posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.serverError = error.error;
        this.response.success = false;
        this.posting = false;
      });
  }

  async ProcessDoctors(doctors: DoctorList[]): Promise<void> {
    const temp: SelectItem[] = [{ label: 'Select Doctor', value: null }];
    for (const doctor of doctors) {
      temp.push({
        label:
          doctor.first_name + ' ' + (doctor.middle_name==null?'':doctor.middle_name) + ' ' + doctor.last_name,
        value: doctor.user_guid
      });
    }
    this.doctor_list = temp;
  }

  async getMemberList(): Promise<void> {
    await this.patientservice
      .getMember(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result: PromiseResult) => {
        if (result.success) {
          const temp: SelectItem[] = [{ label: 'Select Member', value: null }];
          for (let i = 0; i < result.data.patient.length; i++) {
            temp.push({
              label:
                result.data.patient[i].first_name +
                ' ' +
                (result.data.patient[i].middle_name==null?'':result.data.patient[i].middle_name) +
                ' ' +
                result.data.patient[i].last_name,
              value: result.data.patient[i].patient_guid
            });
          }
          this.members = temp;
          this.member_value = null;
        }
      });
  }

  async sendMessage(): Promise<void> {
    await this.ResetResultModels();
    this.posting = true;
    await this.messageService
      .CreateMessage(this.message, this.user)
      .toPromise()
      .then((result: PromiseResult) => {
        this.response = result;
        this.posting = false;
      })
      .catch((error) => {
        this.posting = false;
        this.response.success = false;
        this.serverError = error.error;
      });
  }

  async Discard(): Promise<void> {
    // what to do here?
  }

  async onMemberChange(): Promise<void> {
    if (this.message.patient_guid != null)
      await this.GetDoctors(this.message.patient_guid);
  }

  RouterNavigation(path: string) {
    this.router.navigate(['/' + this.slug + '/patient/' + path]);
  }
}
